import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/fraction-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/fraction-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/fraction-calculator",
      title: m.fr_meta_title(),
      description: m.fr_meta_description(),
      toolName: m.fr_tool_name(),
      faqs: [
        { q: m.fr_faq_q1(), a: m.fr_faq_a1() },
        { q: m.fr_faq_q2(), a: m.fr_faq_a2() },
        { q: m.fr_faq_q3(), a: m.fr_faq_a3() },
        { q: m.fr_faq_q4(), a: m.fr_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
